module.exports = __webpack_public_path__ + "static/media/IMG_8329_cropped3.aa5200f8.jpg";